import {useCallback} from 'react';

import {
  trackWorkspaceError as trackWorkspaceErrorEvent,
  WorkspaceErrorAction,
  WorkspaceErrorType,
} from '../../services/analytics';
import {useViewer} from '../../state/viewer/hooks';
import {LoadableView} from '../../state/views/types';
import {viewerIsWbAdminUsingPrivileges} from '../../util/admin';

export function useTrackWorkspaceError({
  action,
  errorType,
  viewType,
}: {
  action: WorkspaceErrorAction;
  errorType: WorkspaceErrorType;
  viewType: LoadableView['type'] | undefined;
}) {
  const viewer = useViewer();

  const trackWorkspaceError = useCallback(
    (error?: any) => {
      trackWorkspaceErrorEvent({
        action,
        errorType,
        viewerIsUsingAdminPowers: viewerIsWbAdminUsingPrivileges(viewer),
        viewType,
        error,
      });
    },
    [action, errorType, viewType, viewer]
  );

  return trackWorkspaceError;
}
